export enum ELogLevel {
	ERROR = 'bg-brand-error-500',
	WARNING = 'bg-brand-warning-500',
	SUCCESS = 'bg-brand-success-600',
}

